module.exports = __webpack_public_path__ + "static/loja-8b5d2f04b046f04de7576aba567703cd.jpg";